(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('GraphicArchiveItemIbqDetailController', GraphicArchiveItemIbqDetailController);

    GraphicArchiveItemIbqDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'GraphicArchiveItem', 'MusicalPiece', 'Publisher', 'Country', 'Person'];

    function GraphicArchiveItemIbqDetailController($scope, $rootScope, $stateParams, previousState, entity, GraphicArchiveItem, MusicalPiece, Publisher, Country, Person) {
        var vm = this;

        vm.graphicArchiveItem = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('virtuallibraryApp:graphicArchiveItemUpdate', function(event, result) {
            vm.graphicArchiveItem = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
